import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=43f1ea6f&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f1ea6f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43f1ea6f')) {
      api.createRecord('43f1ea6f', component.options)
    } else {
      api.reload('43f1ea6f', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=43f1ea6f&scoped=true&", function () {
      api.rerender('43f1ea6f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2F49R00KfE3Gz/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports